/* eslint-disable */

export default function printModuleVersion(currentVersion) {
  const message = `BB Practice Components v${currentVersion}       ~ OneClick.es`
  console.log(message)
}
